// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__iA09v","sub_container":"WordGameLayout_sub_container__OQRQg"};